import { useCallback, useMemo } from "react"

import { bindActionCreators } from "redux"
import { addTranslationForLanguage, setActiveLanguage } from "react-localize-redux"
import { useDispatch, useSelector } from "react-redux"
import { Button, Dropdown, Menu } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGlobeEurope } from "@fortawesome/pro-duotone-svg-icons"

import { setLanguage } from "../../utils/locale"
import { ColorsPalette } from "../../config/colors"
import { selectActiveLanguage } from "../../reducers/LanguageReducer"
import { selectLanguages } from "../../reducers/LocaleReducer/LocalReducer"

const AnonymousLanguagesMenu = ({ icon }) => {
  const translatedLanguages = useSelector(selectLanguages)
  const currentLanguage = useSelector(selectActiveLanguage)
  const dispatch = useDispatch()

  const dispatchAddTranslation = useMemo(() => bindActionCreators(addTranslationForLanguage, dispatch), [])
  const dispatchSetActiveLanguage = useMemo(() => bindActionCreators(setActiveLanguage, dispatch), [])

  const handleSetLanguage = useCallback(language => e => setLanguage({
    language: language.code,
    addTranslationForLanguage: dispatchAddTranslation,
    setActiveLanguage: dispatchSetActiveLanguage,
  }), [dispatchAddTranslation, dispatchSetActiveLanguage, setLanguage])

  const languagesMenu = useMemo(() => {
    return (
      <Menu>
        {translatedLanguages.map(language => (
          <Menu.Item
            className='ant-dropdown-menu-item'
            key={language.code}
            onClick={handleSetLanguage(language)}
          >
            <FontAwesomeIcon
              icon={faGlobeEurope}
              style={{
                color: currentLanguage.active === language.active
                  ? ColorsPalette.BLUE_ICON
                  : ColorsPalette.TRANSPARENT
              }}
            />
            {language.name}
          </Menu.Item>
        ))}
      </Menu>
    )
  }, [translatedLanguages])

  return (
    <Dropdown
      overlay={languagesMenu}
      trigger={['click']}
    >
      <Button type={'default'}>
        <FontAwesomeIcon icon={icon} /> 
        <span className="ml-8">{currentLanguage.code.toUpperCase()}</span>
      </Button>
    </Dropdown>
  )
}

export default AnonymousLanguagesMenu